import React, { Component } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import App from './App';
import About from './FAQ';
import Posts from './Posts';
import PostsSingle from './PostsSingle';

class Router extends Component {

  render() {

    return (
      <BrowserRouter>
        <Route
          render={({ location }) => (


              <TransitionGroup>
                <CSSTransition key={location.key} classNames="fade" timeout={300}>
                  <Switch location={location}>
                    <Route exact path='/' component={App}/>
                    <Route exact path='/about' component={About}/>
                    <Route exact path='/posts' component={Posts}/>
                    <Route exact path='/posts/:hash' component={PostsSingle}/>
                  </Switch>
                </CSSTransition>
              </TransitionGroup>

          )}
        />
      </BrowserRouter>
    );
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js